import React, { Component } from "react";

import { fetcher } from "../../services/sagas/fetcher.saga";
import logoLaddition from "../../img/logo_laddition.png";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";

class NewOrder extends Component {
  constructor(props) {
    super(props);
    this.splitSearch = this.splitSearch.bind(this);
  }

  componentDidMount() {
    const searchSplit = this.splitSearch();
    const confirm = searchSplit.confirm === "?confirm=true" ? "validated" : "declined";
    const idOrder = searchSplit.idOrder;

    fetcher("PUT", `order/informed/${idOrder}/${confirm}`);
  }

  splitSearch() {
    const { search } = this.props.location;
    const searchSplit = search.split("/");
    const confirm = searchSplit[0];
    const idOrder = searchSplit[1];
    const result = { confirm, idOrder };
    return result;
  }

  render() {
    const searchSplit = this.splitSearch();
    const confirm = searchSplit.confirm === "?confirm=true" ? true : false;
    const idOrder = searchSplit.idOrder;
    const { userData } = this.props;
    return (
      <div id="container-admin-new-order">
        <header style={{ height: 250 }}>
          <div className="content">
            <div className="circle-orange" />
            <div id="title">
              <h1 className="logo">
                <NavLink
                  activeClassName={"active"}
                  to={"/general"}
                  className={` ${!window.chrome ? "topLine" : ""}`}
                >
                  <img src={logoLaddition} alt="logo laddition" /> / La Commande
                  en ligne
                </NavLink>
              </h1>
            </div>
            <h1 className="title">
              {confirm ? "Commande acceptée" : "Commande refusée"}
            </h1>
          </div>
          <div className="bg-white" />
        </header>
        <div className="information">
          <h2>
            {confirm
              ? "Vous avez validé la commande suivante: "
              : "Vous avez refusé la commande suivante: "}
          </h2>
          <span>n°: {idOrder}</span>
          <div className="container-info-customer">
            <h4 className="title-info-customer">
              Informations concernant le client:
            </h4>
            <ul>
              <li>Nom: {userData.lastName}</li>
              <li>Email: {userData.email}</li>
              <li>Téléphone: {userData.phone}</li>
            </ul>
            <p className="title-margin">
              {confirm
                ? "un mail de confirmation a été envoyé au client"
                : "un mail d'annulation a été envoyé au client"}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { user } = state;
  return {
    userData: user.user
  };
};
export default connect(
  mapStateToProps,
  null
)(NewOrder);
